import { isBrowser } from "../helpers/env";
// @ts-ignore
// @ts-nocheck
import { register } from "timeago.js/lib/register";
import en from "timeago.js/lib/lang/en_US";

// A nyelvek kifejezett terkepben allnak, mert a valtozot tartalmazo import()-ot sem a
// Vite, sem a rollup nem tudja elemezni - a webpack magic commentjei helyett ez a
// szabvanyos, minden kotegeloval mukodo alak.
const loaders = {
    hu: () => import("timeago.js/lib/lang/hu"),
    it: () => import("timeago.js/lib/lang/it"),
    es: () => import("timeago.js/lib/lang/es"),
    pl: () => import("timeago.js/lib/lang/pl"),
    el: () => import("timeago.js/lib/lang/el"),
    nl: () => import("timeago.js/lib/lang/nl"),
    tr: () => import("timeago.js/lib/lang/tr"),
    ro: () => import("timeago.js/lib/lang/ro"),
    de: () => import("timeago.js/lib/lang/de"),
    ja: () => import("timeago.js/lib/lang/ja"),
    da: () => import("timeago.js/lib/lang/da"),
    lt: () => import("./lang/lt"),
    et: () => import("./lang/et"),
    ga: () => import("./lang/ga"),
    hr: () => import("./lang/hr"),
};

register("en_US", en);

if (isBrowser) {
    window.registerLanguageForTimeago = async function (lang) {
        const load = loaders[lang];
        if (!load) return;
        const { default: mod } = await load();
        register(lang, mod);
    };
}
